module.exports = __webpack_public_path__ + "static/media/proj_diochemie.802625d1.png";